import { JWT_KEY_FROM_URL } from '../constants/jwtConstant';

const TOKEN_KEY = 'access_token';
const RETURN_TO_KEY = 'auth_return_to';

export interface IAuthService {
    setToken(token: string | null): void;
    getToken(): string | null;
    removeToken(): void;
    isTokenExits(): boolean;
    peekReturnTo(): string | null;
    syncTokenFromUrl(search?: string): boolean;
    saveReturnTo(path?: string): void;
    consumeReturnTo(): string | null;
}

const authService: IAuthService = {
    /**
     * Stores the JWT in localStorage safely.
     */
    setToken(token: string | null): void {
        if (!token) return;
        localStorage.setItem(TOKEN_KEY, token);
    },

    /**
     * Retrieves the token. Returns null if not found.
     */
    getToken(): string | null {
        if (globalThis.window === undefined) return null;
        return localStorage.getItem(TOKEN_KEY);
    },

    /**
     * Clears the token from storage.
     */
    removeToken(): void {
        localStorage.removeItem(TOKEN_KEY);
    },

    /**
     * Simple check to see if a token exists.
     * Note: This doesn't check if the token is EXPIRED, just if it exists.
     */
    isTokenExits(): boolean {
        const token = this.getToken();
        return !!token;
    },

    peekReturnTo(): string | null {
        if(globalThis.window === undefined) return null;
        return sessionStorage.getItem(RETURN_TO_KEY);
    },

    syncTokenFromUrl(search?: string): boolean {
        if (globalThis.window === undefined) return false;
        const searchString = search ?? globalThis.window.location.search;
        const params = new URLSearchParams(searchString);
        const jwt = params.get(JWT_KEY_FROM_URL);
        if (jwt) {
            this.setToken(jwt);
            return true;
        }
        return false;
    },

    saveReturnTo(path?: string): void {
        if (globalThis.window === undefined) return;
        const target = path ?? (globalThis.window.location.pathname + globalThis.window.location.search);

        if(!target.startsWith('/') || target.startsWith('//')) return;

        sessionStorage.setItem(RETURN_TO_KEY, target);
    },

    consumeReturnTo(): string | null {
        if (globalThis.window === undefined) return null;
        const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
        sessionStorage.removeItem(RETURN_TO_KEY);
        if (!returnTo) return null;

        const isSafe = returnTo.startsWith('/') && !returnTo.startsWith('//');
        return (isSafe) ? returnTo : null;
    }
};

export default authService;